import { useMutation } from '@apollo/client';
import format from 'date-fns/format';
import { useNavigate } from 'react-router-dom';

import { createAppointmentMutation } from '@eluve/frontend-appointment-hooks';
import { useNamedLogger } from '@eluve/logger';
import { useAnalytics } from '@eluve/posthog-react';
import {
  useTenantIdFromParams,
  useUserIdFromSession,
} from '@eluve/session-helpers';
import { useConfigStore } from '@eluve/smart-blocks';

export const useStartAnonymousSession = () => {
  const [insertAnonymousAppointment] = useMutation(createAppointmentMutation);

  const logger = useNamedLogger('HomePage');
  const tenantId = useTenantIdFromParams();
  const userId = useUserIdFromSession();
  const { config } = useConfigStore(tenantId, userId);
  const navigate = useNavigate();
  const analytics = useAnalytics();

  return async () => {
    const startDate = new Date();

    const { data, errors } = await insertAnonymousAppointment({
      variables: {
        startDate: startDate.toISOString(),
        name: `New Session ${format(startDate, 'yyyy-MM-dd HH:mm')}`,
        locationId: config.activeLocationId,
      },
    });

    const appointmentId = data?.insertAppointmentsOne?.id;
    if (appointmentId) {
      analytics.capture('created_new_session', {
        tenantId,
        appointmentId,
      });
      navigate(`/organizations/${tenantId}/appointments/${appointmentId}`);
      return;
    }
    logger.error('Error creating new appointment', { errors });
    return;
  };
};
